import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { AppState } from 'store/store';
import { motordromesServices } from 'api/services';
import { MainButton } from 'components/MainButton/MainButton';
import Template from 'components/Template/Template';
import { ShowNotification } from 'helpers/showNotice';
import { NoticeStatus } from 'store/ducks/notice/types';
import Confirmation from 'components/Confirmation/Confirmation';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { IResMotordrome } from 'api/services/motordromes/types';
import * as serviceActions from 'store/ducks/services/actions';
import { isSuRole } from 'helpers/checkRoles';
import './MotordromesPage.sass';

export const MotordromesPage: React.FC = () => {
  const [selectedMotordromes, setSelectedMotordromes] = useState<number>();
  const confirmationRef = useRef<any>();
  const { user } = useSelector((state: AppState) => state.users);
  const lang = useSelector((state: AppState) => state.i18n.key);
  const i18n = useSelector(
    (state: AppState) => state.i18n.data.pages.MotordromesPage
  );
  const { motordromes } = useSelector((state: AppState) => state.services);
  const dispatch = useDispatch();

  useEffect(() => {
    getMotordromes();
  }, []);

  const getMotordromes = async () => {
    if (!motordromes.length) dispatch(serviceActions.getMotordromes());
  };

  const openConfirm = (id: number) => {
    confirmationRef.current.onShow();
    setSelectedMotordromes(id);
  };

  const deleteMotordome = async () => {
    if (!selectedMotordromes) return;
    try {
      await motordromesServices.deleteMotordrome(selectedMotordromes);
      ShowNotification(i18n.motordromeDeleted, NoticeStatus.INFO);
      dispatch(serviceActions.getMotordromes());
    } catch {
      ShowNotification(i18n.error);
    }
  };

  return (
    <Template>
      <div className='motordromes-page'>
        <Confirmation
          title={i18n.wantDeleteMotordrome}
          submit={deleteMotordome}
          ref={confirmationRef}
        />
        <div className='motordromes-page__in'>
          <div className='motordromes-page__row'>
            <Typography variant='h3'> {i18n.motordromes}</Typography>
            {isSuRole(user) && <MainButton link='/motordromes/create' />}
          </div>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>№</TableCell>
                  <TableCell>{i18n.name}</TableCell>
                  <TableCell>{i18n.createdAt}</TableCell>
                  {isSuRole(user) && <TableCell>{i18n.actions}</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {motordromes?.map((i, index) => (
                  <TableRow key={i.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{i[`title${lang}`]}</TableCell>
                    <TableCell>
                      {moment(i.createdAt).format('DD.MM.YYYY')}
                    </TableCell>
                    {isSuRole(user) && (
                      <TableCell>
                        <div className='btn-row'>
                          <Link to={`/motordromes/${i.id}`}>
                            <EditIcon
                              className='edit-icon'
                              sx={{ fontSize: 25, color: '#003956' }}
                            />
                          </Link>
                          <DeleteForeverIcon
                            className='delete-icon'
                            onClick={() => openConfirm(i.id)}
                            sx={{ fontSize: 25, color: '#ff0000' }}
                          />
                        </div>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </div>
      </div>
    </Template>
  );
};
